import { Text } from "@clipboard-health/ui-components";
import { IonPage } from "@ionic/react";
import { Alert, Stack } from "@mui/material";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { AppBarHeader, BackButtonLink } from "@src/appV2/lib/AppBarHeader";
import { PageWithHeader } from "@src/appV2/lib/Layouts";

import { useATeamStatus } from "../useATeamStatus";
import { useGetATeamWorkplaces } from "../useGetATeamWorkplaces";
import { ATeamBenefits } from "./ATeamBenefits";
import { ATeamList } from "./ATeamList";

export function ATeamPage() {
  const { aTeamWorkplaces, isATeamWorkplaceLoading, refetchATeamWorkplaces } =
    useGetATeamWorkplaces();
  const { isATeamOffExperimentEnabled } = useATeamStatus();

  return (
    <IonPage>
      <PageWithHeader
        containerVariant="without-margin"
        containerMaxWidth="lg"
        appBarHeader={
          <AppBarHeader
            title="Priority Plus"
            leftCta={
              <BackButtonLink
                alwaysUseDefaultBackTo
                defaultBackTo={DeprecatedGlobalAppV1Paths.RATINGS}
              />
            }
          />
        }
        onRefresh={refetchATeamWorkplaces}
      >
        <Stack gap={4} padding={2}>
          {isATeamOffExperimentEnabled && (
            <Stack>
              <Alert severity="info" variant="insight">
                Not seeing one of your regular facilities here? Facilities in your area are
                transitioning away from manually maintaining Priority Plus lists. Instead,
                you&apos;ll receive more Priority Access automatically by having a high Clipboard
                Score and by working at the facility frequently!
              </Alert>
            </Stack>
          )}
          <Stack gap={1}>
            <Text
              variant="h2"
              sx={{
                color: "#424242",
                fontSize: "22px",
                fontWeight: "700",
              }}
            >
              Priority Plus
            </Text>
            <Text variant="body2">
              Priority Plus status is given by a workplace to a select few of their best performing
              professionals. Their A-Team!
            </Text>
          </Stack>
          <ATeamBenefits />
          <ATeamList workplaces={aTeamWorkplaces} isLoading={isATeamWorkplaceLoading ?? false} />
        </Stack>
      </PageWithHeader>
    </IonPage>
  );
}
